import Qs from "qs";
import { parseUrlArray } from "@edgetier/utilities";
import { InteractionType } from "@edgetier/watchtower-types";

/**
 * Find all interaction types selected from URL
 * @param search URL query parameters
 */
export const getInteractionTypeFromUrl = (search: string) => {
    const { interactionType } = Qs.parse(search, { ignoreQueryPrefix: true });
    return parseUrlArray<InteractionType>(interactionType);
};
